import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { FormFeedback } from 'reactstrap'
import styles from './InputFeedback.scss'

const InputFeedback = ({ isDisplayed = false, children }) => (
  <FormFeedback className={cx(styles.feedback, { [styles.visible]: isDisplayed })}>{children}</FormFeedback>
)

InputFeedback.propTypes = {
  isDisplayed: PropTypes.bool,
  children: PropTypes.any.isRequired,
}

export default InputFeedback
